import { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../../helper/api';

const IncomeOutsideOrders = ({ token }) => {
    const [amount, setAmount] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!amount || amount <= 0) {
            alert('Masukkan jumlah uang masuk yang valid');
            return;
        }

        setIsLoading(true);
        
        try {
            await axios.post(`${API_URL}/income-outside-orders?token=${token}`, { amount });
            alert('✅ Uang masuk berhasil dicatat!');
            setAmount('');
        } catch (error) {
            console.error('Income recording error:', error);
            alert('❌ Gagal mencatat uang masuk!');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="w-full max-w-md mt-5">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
                <div className="text-center mb-8">
                    <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                        Uang Masuk
                    </h2>
                    <p className="text-gray-500 text-sm">dari Luar Orders</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="income-amount" className="block text-sm font-medium text-gray-700 mb-2">
                            Jumlah Uang Masuk
                        </label>
                        <div className="relative">
                            <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
                                Rp
                            </span>
                            <input
                                id="income-amount"
                                type="number"
                                placeholder="0"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                required
                                min="1"
                                className="w-full pl-10 pr-4 py-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 text-lg placeholder-gray-400"
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white font-semibold py-4 px-6 rounded-xl transition-colors duration-200 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:outline-none"
                    >
                        {isLoading ? 'Memproses...' : 'Simpan Uang Masuk'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default IncomeOutsideOrders; 